import * as React from "react";
export var status;
(function (status) {
    status["active"] = "active";
    status["complete"] = "complete";
})(status || (status = {}));
var StepsIndicator = function (props) {
    var data = props.data;
    var current = 0;
    var next = 0;
    var nextStep;
    var currentStep;
    var count = data === null || data === void 0 ? void 0 : data.length;
    data === null || data === void 0 ? void 0 : data.map(function (d, i) {
        if (d.status == status.active) {
            current = i;
            currentStep = data[current].label;
            next = i + 1;
            if (next < count)
                nextStep = data[next].label;
        }
    });
    return (React.createElement("div", { className: "fr-stepper" },
        React.createElement("h2", { className: "fr-stepper__title" },
            React.createElement("span", { className: "fr-stepper__state" },
                "\u00C9tape ",
                current + 1,
                " sur ",
                count),
            currentStep),
        React.createElement("div", { className: "fr-stepper__steps", "data-fr-current-step": current + 1, "data-fr-steps": count }),
        next + 1 < count ? (React.createElement("p", { className: "fr-stepper__details" },
            React.createElement("span", { className: "fr-text--bold" }, "\u00C9tape suivante :"),
            " ",
            nextStep)) : null));
};
export default StepsIndicator;
